import { TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function home1() {
    const { useLang, useEffect, useRouter, useState, useRef } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    const fadeIn = () => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
        const target = document.querySelector(`.kitProduct .mm100_home1 .textBox`) as HTMLElement;
        const targetH = 150;
        const tween1 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 0 });
        const scene1 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: 0,
            triggerHook: 1, // 1进入， 0：离开
            duration: targetH,
        });
        scene1.setTween(tween1);
        scene1.addTo(AniContainer);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: targetH,
            triggerHook: 1,
            duration: targetH,
        });
        const tween2 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 1 });
        scene2.setTween(tween2);
        scene2.addTo(AniContainer);

        // const scene3 = new ScrollMagic.Scene({
        //     triggerElement: target,
        //     offset: targetH * 2,
        //     triggerHook: 1,
        //     duration: layoutH - targetH * 3,
        // })
        // const tween3 = TweenMax.fromTo(target, 0.5, { opacity: 1 }, { opacity: 1 })
        // scene3.setTween(tween3)
        // scene3.addTo(AniContainer)

        // const scene4 = new ScrollMagic.Scene({
        //     triggerElement: target,
        //     offset: layoutH - targetH,
        //     triggerHook: 1,
        //     duration: targetH,
        // })
        // const tween4 = TweenMax.fromTo(target, 0.5, { opacity: 1 }, { opacity: 0 })
        // scene4.setTween(tween4)
        // scene4.addTo(AniContainer)
    };

    useEffect(() => {
        // 文字透明渐变 - 进入
        fadeIn();
    }, []);

    const [enter, setEnter] = useState(false);
    const videoRef = useRef();
    useEffect(() => {
        // mm100_home1进入视窗渲染video
        const videoEl = document.querySelector('.kitProduct .mm100_home1') as HTMLElement;
        const scene = new ScrollMagic.Scene({
            triggerElement: videoEl,
            triggerHook: 1,
            offset: 0,
        });
        scene.on('enter', () => {
            setEnter(true);
        });
        scene.addTo(AniContainer);
    }, []);

    useEffect(() => {
        if (videoRef) {
            const videoBoxEl = document.querySelector('.mm100_home1 .videoBox') as HTMLElement;
            // 视频的一半区域进入视窗后开始播放
            const scene1 = new ScrollMagic.Scene({
                triggerElement: '.kitProduct .mm100_home1 .videoBox',
                triggerHook: 1,
                offset: videoBoxEl?.offsetHeight / 2,
            });
            scene1.on('enter', () => {
                videoRef?.current?.play();
            });
            AniContainer.addScene(scene1);
        }
    }, [videoRef]);

    return (
        <div className={`mm100_home1 ${css.mm100_home1}`}>
            <div className="textBox">
                <p className="navTitle">{t('presale.product.home1_navTitle')}</p>
                <p className="title">{t('presale.product.home1_title')}</p>
                <p className="text">{t('presale.product.home1_text')}</p>
            </div>
            <div className="videoBox">
                {enter && (
                    <EFVideo
                        ref={videoRef}
                        className="mm100_home1_video"
                        sources={['/video/mm100/kv.webm', '/video/mm100/kv.mp4']}
                        width={'100%'}
                        height={'100%'}
                        playsInline
                        autoPlay={false}
                        loop
                        preload="auto"
                        muted
                    />
                )}
            </div>
        </div>
    );
}
